const firebaseConfig = {
  apiKey: "AIzaSyAn08XT3kbkzQkbg4RaaPo5vzvWd6otzrs",
  authDomain: "sunstore-368e4.firebaseapp.com",
  projectId: "sunstore-368e4",
  storageBucket: "sunstore-368e4.appspot.com",
  messagingSenderId: "739702068262",
  appId: "1:739702068262:web:1ac700e5d5ecc2528582e7"
};
export default firebaseConfig;  